var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ringing)?_c('ringer'):_vm._e(),(_vm.isConnected&&_vm.provider=='agora')?_c('agora-client'):_vm._e(),(_vm.isConnected&&_vm.provider=='twilio')?_c('twilio-client'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }